/* eslint-disable react/no-array-index-key */
import { useEffect } from 'react';
import { HeadingDescSmall, HeadingDescVsmall } from '../../Headings';
import { RatingStars } from '../../rating';
import './doctorReviewCard.css';

function DoctorReviewCard(props) {
  const { data } = props;

  useEffect(() => {
    // const checkBtnText = data;
    // const selectCard = document.getElementsByClassName('doctorReviewCard');
    // const findStatusDiv = document.querySelector('.doctorStatus');
    // eslint-disable-next-line prettier/prettier
    // const checkStatus = findStatusDiv.querySelectorAll('.headingDescVsmall');
    for (let i = 0; i < data.length; i += 1) {
      // console.log(data[i]);
      // if (checkStatus[i].innerHTML === 'IN-PERSON') {
      //   checkStatus[i].classList.add('t-tifannyblue');
      //   console.log(checkStatus[i].innerHTML);
      // } else {
      //   checkStatus[i].classList.add('t-rosepink');
      // }
    }
  });
  return data.map((doctorReviewCard, index) => {
    const { name, time, status, rating, comment } = doctorReviewCard;
    return (
      <div className="doctorReviewCard" key={index}>
        <div className="firstRow">
          <div className="info">
            <div className="name">
              <HeadingDescVsmall text={name} />
            </div>
            <div className="time">
              <HeadingDescVsmall text={`| ${time}`} />
            </div>
            {status && (
              <div className="doctorStatus">
                <HeadingDescVsmall text={`| ${status}`} />
              </div>
            )}
          </div>
          {rating && (
            <div>
              <RatingStars newValue={rating} />
            </div>
          )}
        </div>
        <div className="content">
          <HeadingDescSmall text={comment} />
        </div>
      </div>
    );
  });
}

export default DoctorReviewCard;
